import { MetaOfferContentsMetadata } from '../../features/cart/shop-cart/interfaces/shop-cart.interface';
import { OfferTypeChecker } from './offer-type-util';

export function isAleksSharpenCompanionBundle(
    offerType?: string,
    isSharpenCompanion = false
): boolean {
  return OfferTypeChecker.isAleks(offerType) && !!isSharpenCompanion;
}

export function fetchAleksProductTitleVerbose(metaOfferContents?: MetaOfferContentsMetadata[]): string {
  const title = metaOfferContents?.find((content) =>
    OfferTypeChecker.isAleks(content?.offerType)
  )?.title || '';

  return title ? `${title} + Sharpen Companion` : '';
}

export function fetchAleksBundleDurationInDays(
    metaOfferContents?: MetaOfferContentsMetadata[]
): number | undefined {
  return metaOfferContents?.find((content) =>
    OfferTypeChecker.isAleks(content?.offerType)
  )?.duration;
}

export function fetchSharpenCompanionBundleDurationInDays(
  metaOfferContents?: MetaOfferContentsMetadata[]
): number | undefined {
  return metaOfferContents?.find((content) =>
    OfferTypeChecker.isSharpenCompanion(content?.offerType)
  )?.duration;
}
